<template>
  <div class="aboutIndex">
    <div class="aboutMenu">
      <div class="aboutHeader">
        <div class="logo" @click.stop="flag = false">
          <img src="../../assets/logo.png" style="width: 2.13333rem;height: .53333rem;" />
        </div>
        <div class="openClose">
          <div v-if="flag" @click="flag = false">
            <i class="iconfont">&#xeaf2;</i>
          </div>
          <div v-else @click="flag = true">
            <i class="iconfont">&#xe60a;</i>
          </div>
        </div>
        <div class="menuDiv" :style="flag ? 'left:0;' : 'left:-0.4rem;'" @click.stop="flag = false">
          <div v-if="flag" class="menuList">
            <div
              @click="menuClick('index')"
              class="menuList1"
              :style="
                path == 'index'
                  ? 'color:#2c3e50;background:rgb(247 247 228);border-left:.1rem solid rgb(245 245 4)'
                  : ''
              "
            >
              <router-link :to="{ path: '/about', name: 'about' }" tag="div">首页</router-link>
            </div>
            <div
              @click="menuClick('muqu')"
              class="menuList1"
              :style="
                path == 'muqu'
                  ? 'color:#2c3e50;background:rgb(247 247 228);border-left:.1rem solid rgb(245 245 4)'
                  : ''
              "
            >
              <router-link :to="{ path: '/myyq', name: 'myyq' }" tag="div">墓园园区</router-link>
            </div>
            <div
              @click="menuClick('beixing')"
              class="menuList1"
              :style="
                path == 'beixing'
                  ? 'color:#2c3e50;background:rgb(247 247 228);border-left:.1rem solid rgb(245 245 4)'
                  : ''
              "
            >
              <router-link :to="{ path: '/beixing', name: 'beixing' }" tag="div"
                >碑型推荐</router-link
              >
            </div>
            <!-- <div
              @click="menuClick('guanjia')"
              class="menuList1"
              :style="
                path == 'guanjia'
                  ? 'color:#2c3e50;background:rgb(247 247 228);border-left:.1rem solid rgb(245 245 4)'
                  : ''
              "
            >
              <router-link :to="{ path: '/guanjia', name: 'guanjia' }" tag="div"
                >购墓管家</router-link
              >
            </div> -->
            <div
              @click="menuClick('bingyi')"
              class="menuList1"
              :style="
                path == 'bingyi'
                  ? 'color:#2c3e50;background:rgb(247 247 228);border-left:.1rem solid rgb(245 245 4)'
                  : ''
              "
            >
              <router-link :to="{ path: '/byyw', name: 'byyw' }" tag="div">殡仪业务</router-link>
            </div>
            <div
              @click="menuClick('shengqian')"
              class="menuList1"
              :style="
                path == 'shengqian'
                  ? 'color:#2c3e50;background:rgb(247 247 228);border-left:.1rem solid rgb(245 245 4)'
                  : ''
              "
            >
              <router-link :to="{ path: '/sqqy', name: 'sqqy' }" tag="div">生前契约</router-link>
            </div>
            <div
              class="menuList1"
              :style="
                path == 'fuwu' ||
                path == 'phzb' ||
                path == 'xhzs' ||
                path == 'msgj' ||
                path == 'jsyp' ||
                path == 'qtfw'
                  ? 'color:#2c3e50;background:rgb(247 247 228);border-left:.1rem solid rgb(245 245 4)'
                  : ''
              "
            >
              <div @click.stop="menuClick('fuwu')">嘉盛服务</div>

              <!-- <router-link :to="{ path: '/jsfw', name: 'jsfw' }" tag="div">嘉盛服务</router-link> -->
              <div
                class="child"
                v-if="
                  path == 'fuwu' ||
                    path == 'phzb' ||
                    path == 'xhzs' ||
                    path == 'msgj' ||
                    path == 'jsyp' ||
                    path == 'qtfw'
                "
              >
                <div @click="menuClick('phzb')">
                  <router-link :to="{ path: '/jsfw', name: 'jsfw', params: { type: 0 } }" tag="div"
                    ><span :style="path == 'phzb' ? 'color: #dea767;' : ''"
                      >盆花摆租</span
                    ></router-link
                  >
                </div>
                <div @click="menuClick('xhzs')">
                  <router-link :to="{ path: '/jsfw', name: 'jsfw', params: { type: 1 } }" tag="div"
                    ><span :style="path == 'xhzs' ? 'color: #dea767;' : ''"
                      >鲜花装饰</span
                    ></router-link
                  >
                </div>
                <div @click="menuClick('msgj')">
                  <router-link :to="{ path: '/jsfw', name: 'jsfw', params: { type: 2 } }" tag="div"
                    ><span :style="path == 'msgj' ? 'color: #dea767;' : ''"
                      >墓石改建</span
                    ></router-link
                  >
                </div>
                <div @click="menuClick('jsyp')">
                  <router-link :to="{ path: '/jsfw', name: 'jsfw', params: { type: 3 } }" tag="div"
                    ><span :style="path == 'jsyp' ? 'color: #dea767;' : ''"
                      >祭扫用品</span
                    ></router-link
                  >
                </div>
                <div @click="menuClick('qtfw')">
                  <router-link :to="{ path: '/jsfw', name: 'jsfw', params: { type: 4 } }" tag="div"
                    ><span :style="path == 'qtfw' ? 'color: #dea767;' : ''"
                      >其他服务</span
                    ></router-link
                  >
                </div>
              </div>
            </div>
            <div
              class="menuList1"
              :style="
                path == 'news' || path == 'xwdt' || path == 'hybk' || path == 'khxz'
                  ? 'color:#2c3e50;background:rgb(247 247 228);border-left:.1rem solid rgb(245 245 4)'
                  : ''
              "
            >
              <div @click.stop="menuClick('news')">园区动态</div>

              <div
                class="child1"
                v-if="path == 'news' || path == 'xwdt' || path == 'hybk' || path == 'khxz'"
              >
                <div @click="menuClick('xwdt')">
                  <router-link :to="{ path: '/news', name: 'news', params: { type: 0 } }" tag="div"
                    ><span :style="path == 'xwdt' ? 'color: #dea767;' : ''"
                      >新闻动态</span
                    ></router-link
                  >
                </div>
                <div @click="menuClick('hybk')">
                  <router-link :to="{ path: '/news', name: 'news', params: { type: 1 } }" tag="div"
                    ><span :style="path == 'hybk' ? 'color: #dea767;' : ''"
                      >行业百科</span
                    ></router-link
                  >
                </div>
                <div @click="menuClick('khxz')">
                  <router-link :to="{ path: '/news', name: 'news', params: { type: 2 } }" tag="div"
                    ><span :style="path == 'khxz' ? 'color: #dea767;' : ''"
                      >客户须知</span
                    ></router-link
                  >
                </div>
              </div>
            </div>
            <!-- <div
              @click="menuClick('aboutus')"
              class="menuList1"
              :style="
                path == 'aboutus'
                  ? 'color:#2c3e50;background:rgb(247 247 228);border-left:.1rem solid rgb(245 245 4)'
                  : ''
              "
            >
              <router-link :to="{ path: '/aboutus', name: 'aboutus' }" tag="div"
                >关于我们</router-link
              >
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="content" @click.stop="flag = false">
      <router-view></router-view>
      <van-action-sheet v-model="show" title="购墓预约">
        <div class="content">
          <!-- <goumudengji></goumudengji> -->
          <iframe src="/shop/gmdj" frameborder="0" style="height:10rem;width:100%;"></iframe>
        </div>
      </van-action-sheet>
      <div class="foot1">
        <div class="footMenu1">
          <div class="div0">
            <div class="div1">
              <i class="iconfont">&#xe679;</i
              ><a href="tel:0546-75889977" style="color: #fff;">电话咨询</a>
            </div>
            <div class="div2">
              <i class="iconfont">&#xe62f;</i
              ><a href="https://work.weixin.qq.com/kfid/kfc10fd463b85635b1b" style="color:#fff;"
                >在线客服</a
              >
            </div>
          </div>
          <div class="div3" @click="show = true"><i class="iconfont">&#xe60d;</i> 购墓预约</div>
        </div>
      </div>
    </div>
    <div class="home-footer">
      <div class="footerDiv-box">
        <img src="../../assets/ft1.png" alt="" /><br />
        24小时服务热线：0546-75889977<br />
        东营市东营区崂山路东段<br />2022-2023 嘉盛陵园版权所有
        <a href="http://beian.miit.gov.cn/" target="_blank" style="color:#fff;">
          鲁ICP备0000000号 </a
        ><br />
        <img src="../../assets/ft2.jpg" alt="" style="width:3rem;height:3rem;margin-top:.5rem;" />
      </div>
    </div>
    <!-- <div class="foot">
      <div class="footMenu">
        <div><i class="iconfont">&#xe679;</i>电话咨询</div>
        <div><i class="iconfont">&#xe62f;</i>在线客服</div>
        <div><i class="iconfont">&#xe60d;</i> 购墓预约</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import bus from '../../common/bus'
export default {
  name: 'aboutIndex',
  data() {
    return {
      flag: false,
      path: 'index',
      show: false,
    }
  },
  created() {
    bus.$off('path')
    console.log(123)
    bus.$on('path', msg => {
      this.path = msg
    })
  },
  methods: {
    menuClick(url) {
      this.path = url

      if (url != 'fuwu' && url != 'news') {
        this.flag = false
      }
    },
  },
}
</script>

<style>
.home-footer {
  background: #2e2e2e;
  padding: 0.8rem 0;
  text-align: center;
  height: 10rem;
  color: #fff;
  line-height: 0.8rem;
}
.home-footer img {
  width: 4rem;
  height: 1rem;
  margin: 0 auto 0.2rem;
}
.aboutIndex .menuList1 {
  position: relative;
  width: 3rem;
}
.aboutIndex .child {
  position: absolute;
  top: 0;
  right: -3rem;
  width: 3rem;
  height: 5rem;
  background: #333;
  color: #fff;
  display: block;
}
.aboutIndex .child1 {
  position: absolute;
  top: 0;
  right: -3rem;
  width: 3rem;
  height: 3rem;
  background: #333;
  color: #fff;
  display: block;
}
.aboutIndex .child div,
.aboutIndex .child1 div {
  height: 1rem;
  text-align: center;
}
.aboutIndex .content {
}
.aboutHeader .menuDiv {
  position: absolute;
  transition: all 0.5s ease 0s;
  background: #333;
  color: #fff;
  z-index: 99999;
}
.aboutHeader .openClose {
  position: absolute;
  right: 0.25rem;
  top: 0.3rem;
  color: #fff;
  font-size: 0.5rem !important;
}
.aboutHeader .openClose i {
  font-size: 0.5rem !important;
  color: #fff;
}
.aboutHeader .logo {
  width: 100%;
  height: 1.17333rem;
  background: #333;
  padding: 0.35rem;
  position: relative;
}
.aboutHeader .menuList {
  line-height: 0.8rem;
  width: 100%;
  padding: 0.4rem 0;
}
.aboutHeader .menuList .menuList1 {
  padding: 0 0.4rem;
  height: 1rem;
  line-height: 1rem;
}
.aboutIndex .copyright {
  background: #2e2e2e;
  color: #fff;
  height: 4rem;
  text-align: center;
  padding: 0.5rem;
}
.aboutIndex .foot {
  height: 1rem;
  background: #fff;
  position: fixed;
  bottom: 0.6rem;
  left: 0;
  right: 0;
  z-index: 999;
  width: 100%;
}
.aboutIndex .footMenu {
  height: 0.9rem;
  background: #fff;
  box-shadow: 0 -0.027rem 0.05333rem 0 hsl(0deg 0% 89% / 50%);
  margin-top: 0.3rem;
  padding: 0.21333rem 0.4rem;
  justify-content: space-between;

  display: flex;
  align-items: center;
  color: #dea767;
  border-top: 0.02rem solid #dea767;
}
.aboutIndex .footMenu div {
  background: #dea767;
  color: #fff;
  border-radius: 50rem;
  padding: 0.1rem 0.3rem;
}
.aboutIndex .foot1 {
  height: 1.5rem;
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  width: 100%;
  padding: 0.3rem 0.5rem 0 0.5rem;
}
.aboutIndex .footMenu1 {
  height: 0.9rem;
  background: #fff;

  padding: 0.21333rem 0.4rem;
  justify-content: space-between;

  display: flex;
  align-items: center;
  color: #dea767;
  position: relative;
}
.aboutIndex .footMenu1 .div1 {
  color: #fff;

  padding: 0.2rem 0.3rem;

  border-right: 0.02rem solid #fff;
}
.aboutIndex .footMenu1 .div2 {
  color: #fff;

  padding: 0.2rem 0.3rem;
}
.aboutIndex .footMenu1 .div0 {
  position: absolute;
  background: #dea767;
  left: 0;
  width: 5.1rem;
  border-radius: 50rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.aboutIndex .footMenu1 .div3 {
  position: absolute;
  right: 0;
  border: #dea767 0.02rem solid;
  color: #dea767;
  background: #fff;
  border-radius: 50rem;
  padding: 0.2rem 0.3rem;
}
.aboutIndex .footMenu1 .left {
  width: 2.93rem;
  height: 1.17333rem;
}
.aboutIndex .footMenu1 .left div,
.aboutIndex .footMenu1 .right div {
  display: block;
  width: 2.93rem;
  height: 1.17333rem;
  line-height: 1.17333rem;
  padding-left: 0.96rem;
  color: #333;
  font-size: 0.37333rem;
}
.aboutIndex .footMenu1 .right {
  width: 5.94667rem;
  height: 1.17333rem;
  background: #fff;
  border-radius: 0.58667rem;
  overflow: hidden;
  border: 0.027rem solid #dea767;
  display: flex;
  justify-content: space-between;
}
</style>
